
import Marquee from "react-fast-marquee"
import Image from "next/image"
import modeo from "../../../public/modeologo.png";
import kube from "../../../public/kubelogo.png";
import stafiz from "../../../public/stafizlogo.jpg";
import teeptrack from "../../../public/teeptracklogo.jpg";
import ferpection from "../../../public/ferpectionlogo.svg";
import anaba from "../../../public/anabalogo.png";
import unbottled from "../../../public/unbottledlogo.png";
import cci from "../../../public/ccilogo.png";
import humancraft from "../../../public/humancraftlogo.png";
import uneeti from "../../../public/uneetilogo.png";
import hosman from "../../../public/hosmanlogo.png";

function MarqueeComponant(){
    return(
        <div className="my-20 fadeIn">
            <Marquee autoFill gradient gradientColor={"#FAFAFA"}>
                
                <Image src={modeo} alt="modeo logo" className="mx-10 grayscale opacity-50" width={118}/>
                <Image src={kube} alt="kube logo" className="mx-10 grayscale opacity-50" width={118}/>
                <Image src={stafiz} alt="kube logo" className="mx-10 grayscale opacity-50" width={118}/>
                <Image src={teeptrack} alt="kube logo" className="mx-10 grayscale opacity-50" width={118}/>
                <Image src={ferpection} alt="kube logo" className="mx-10 grayscale opacity-50" width={118}/>
                <Image src={anaba} alt="kube logo" className="mx-10 grayscale opacity-50" width={118}/>
                <Image src={unbottled} alt="kube logo" className="mx-10 grayscale opacity-50" width={118}/>
                <Image src={cci} alt="kube logo" className="mx-10 grayscale opacity-50" width={118}/>
                <Image src={humancraft} alt="kube logo" className="mx-10 grayscale opacity-50" width={118}/>
                <Image src={uneeti} alt="kube logo" className="mx-10 grayscale opacity-50" width={118}/>
                <Image src={hosman} alt="kube logo" className="mx-10 grayscale opacity-50" width={118}/>
            </Marquee>
        </div>
        
    )
}

export default MarqueeComponant